import { Heading } from 'yoso';
import { T } from '~/components/I18n';
import mysteryBox from '~/components/Icon/mysteryBox.png';
import { LevelUpSticky } from '~/components/LevelUp/Sticky/LevelUpSticky';
import './LevelUpFormHero.scss';

export const LevelUpFormHero = () => (
  <div className="level-up-hero">
    <div className="level-up-hero-header">
      <Heading level={3} className="level-up-hero-title">
        <T name="citizen_membership_levelup_page_title" />
      </Heading>
      <p className="level-up-hero-description">
        <T name="citizen_membership_levelup_page_desc" />
      </p>
    </div>
    <div className="level-up-hero-body">
      <img
        className="level-up-hero-image"
        src={mysteryBox}
        width={300}
        height={300}
        alt="mystery box"
      />
    </div>
    <div className="level-up-hero-footer">
      <LevelUpSticky />
    </div>
  </div>
);
